import { NavSection } from './nav-item/nav-item';

export const navSections: NavSection[] = [
  // Primary Navigation Section
  {
    items: [
      {
        displayName: 'Dashboard',
        iconName: '/assets/images/svgs/nav/dashboard.svg',
        route: '/dashboard',
      },
      {
        displayName: 'Invoices',
        iconName: '/assets/images/svgs/nav/invoice.svg',
        route: 'invoices',
      },
      {
        displayName: 'Deposits',
        iconName: '/assets/images/svgs/nav/deposits.svg',
        route: 'deposits',
      },
    ],
  },
  // Secondary Navigation Section
  {
    items: [
      {
        displayName: 'Clients',
        iconName: '/assets/images/svgs/nav/clients.svg',
        route: 'clients',
      },
      {
        displayName: 'Withdraw',
        iconName: '/assets/images/svgs/nav/withdrawl.svg',
        route: 'withdraw',
      },
      {
        displayName: 'Payouts',
        iconName: '/assets/images/svgs/nav/payouts.svg',
        route: 'payouts',
      },
      // {
      //   displayName: 'Compliance Package',
      //   iconName: '/assets/images/svgs/nav/invoice.svg',
      //   route: 'compliance-package',
      // },
      // Affiliates item removed from default navigation
      // It will be added dynamically only for affiliate managers
    ],
  },
  // Footer Navigation Section
  {
    isFooter: true,
    items: [
      {
        displayName: 'Account',
        iconName: '/assets/images/svgs/nav/account.svg',
        route: '/account',
      },
      {
        displayName: 'Settings',
        iconName: '/assets/images/svgs/nav/settings.svg',
        route: '/settings',
      },
    ],
  },
];
